import { useTrads } from "../../contexts/trads/useTrads";
import type { Fond } from "../../types/Fond";
import parse from 'html-react-parser';
import DonsInsertForm from "../Dons/DonsInsertForm";
import './appels.scss';
function AppelsItem({fond}:{fond:Fond}){
    const {translate}=useTrads();
    return (
        <article className="item container-fluid">
            <header className="row">
                <div className="col-md-12">
                    <div className="d-flex flex-wrap">
                        <h1 className="h1-titre">{fond.titre}</h1>
                        
                        {fond.type_frais?
                            <div className="fond-type-frais">
                                <p>{translate("ce fonds sert à financer:")}</p>
                                <ul>
                                {fond.type_frais.map(typeFrais=>{
                                    return (<li key={typeFrais.type_frais_id}>
                                            <button className="btn btn-lg btn-autonomia"  data-toggle="popover" title="{typeFrais.name}" data-content="{$typeFrais.description}">{typeFrais.name}</button>
                                        </li>)
                                })}
                                </ul>
                            </div>
                        :null}
                    </div>

                </div>
            </header>
	        <div className="fond  details  row">

		        <div className="col-12 fond-info">
                    <div>
                        <div className="intro">{translate("qui je suis")}</div>
                        <div className="d-flex">
                            <div className="handifin-logo-profil">
                                <div className="logo-profil media-object">
                                    {fond.vignette ?
                                    <img src={fond.vignette.filename} alt="vignette" /> :null}
                                </div>
                            </div>
                            {fond.chapeau?
                            <div className="handifin-chapeau">
                                {parse(fond.chapeau)}
                            </div>
                            :null}
                        </div>
                    </div>
                    <div >
                        <div className="intro">{translate("Mes besoins")}</div>
                        <div className="d-flex">
                            {fond.objectif?
                            <div>
                                {fond.objectif}
                            </div>
                            :null}


                            {fond.descriptif?
                            <div  className="handifin-descriptif">
                                {parse(fond.descriptif)}
                            </div>
                            :null}
                        </div>
                    </div>
                </div>
                <div className="col-12 fond-don">
                    <DonsInsertForm fond={fond}/>
			    </div>
            </div>
        </article>
    );
}
export default AppelsItem;